import { __spreadValues, __spreadProps } from './chunk-T36PI2YV.mjs';
import intersection from 'lodash/intersection';
import isArray from 'lodash/isArray';

function filter(dataArr, params, sortOption, onSortFunction, orParams, noneSelected, multipleSelected) {
  const statuses = params["statuses"];
  const filteredParams = __spreadValues({}, params);
  delete filteredParams["statuses"];
  const paramsList = Object.entries(filteredParams).filter(([, value]) => value);
  const getIsNoneReturn = (key, itemValue) => {
    if (noneSelected && noneSelected.includes(key)) {
      return itemValue.length === 0;
    }
    return false;
  };
  const getIsMultipleReturn = (key, itemValue) => {
    if (multipleSelected && multipleSelected.includes(key)) {
      return itemValue.length > 1;
    }
    return false;
  };
  const filterFunctions = paramsList.map(
    ([key, value]) => (item) => {
      var _a, _b;
      if (typeof value === "number") {
        if (!isArray(item[key]))
          return item[key] === value;
        const propValue = item[key];
        return getIsNoneReturn(key, propValue) || getIsMultipleReturn(key, propValue) || propValue.includes(value);
      }
      if (typeof value === "string") {
        const arraySome = (element) => element.toLowerCase().trim().includes(value.toLowerCase().trim());
        if (isArray(item[key])) {
          const propValue = item[key];
          return getIsNoneReturn(key, propValue) || getIsMultipleReturn(key, propValue) || propValue.some(arraySome);
        }
        const stringValue = item[key];
        if (!value.includes("\u2264")) {
          let isOrValid = false;
          if (orParams) {
            isOrValid = orParams.some((orParam) => {
              if (isArray(item[orParam])) {
                return item[orParam].some(arraySome);
              }
              const orValue = item[orParam];
              return orValue.toUpperCase().includes(value.toUpperCase());
            });
          }
          return isOrValid || stringValue.toUpperCase().includes(value.toUpperCase());
        }
        const dates = value.replace(/\//g, "-").split("\u2264");
        const lDate = Date.parse(dates[0]);
        const rDate = Date.parse(dates[1]);
        const valueDate = Date.parse(stringValue);
        if (!lDate && rDate) {
          if (valueDate <= rDate)
            return true;
          return false;
        }
        if (!rDate && lDate) {
          if (valueDate >= lDate)
            return true;
          return false;
        }
        if (valueDate >= lDate && valueDate <= rDate)
          return true;
        return false;
      }
      if (isArray(value)) {
        if (value.length === 0)
          return true;
        const propValue = item[key];
        if (typeof propValue === "string") {
          if (isArray(propValue)) {
            return getIsNoneReturn(key, propValue) || getIsMultipleReturn(key, propValue) || intersection(value, propValue).length > 0;
          }
          return value.includes(propValue);
        } else {
          if (isArray(propValue)) {
            return getIsNoneReturn(key, propValue) || getIsMultipleReturn(key, propValue) || intersection(value, propValue).length > 0;
          }
          return value.includes(propValue);
        }
      }
      if (typeof value === "object" && (value == null ? void 0 : value.includes)) {
        return item[key].includes(
          value.includes
        );
      }
      if (typeof value === "object") {
        if (typeof (value == null ? void 0 : value.greaterThan) === "number") {
          return item[key] > value.greaterThan;
        }
        if (typeof (value == null ? void 0 : value.lessThan) === "number") {
          return item[key] < value.lessThan;
        }
        if (typeof (value == null ? void 0 : value.greaterThanEqual) === "number") {
          return item[key] >= value.greaterThanEqual;
        }
        if (typeof (value == null ? void 0 : value.lessThanEqual) === "number") {
          return item[key] <= value.lessThanEqual;
        }
        if (typeof (value == null ? void 0 : value.notEqual) === "number") {
          return item[key] !== value.notEqual;
        }
        if (typeof (value == null ? void 0 : value.equal) === "number") {
          return item[key] === value.equal;
        }
        if (typeof (value == null ? void 0 : value.endsWith) === "string") {
          return (_a = item[key]) == null ? void 0 : _a.endsWith(value.endsWith);
        }
        if (typeof (value == null ? void 0 : value.includes) === "string") {
          return (_b = item[key]) == null ? void 0 : _b.includes(value.includes);
        }
      }
      return false;
    }
  );
  const result = dataArr.map((item) => {
    if (statuses && statuses > 0 && Array.isArray(item.children)) {
      const originalChildren = item.children;
      const isActive = statuses === 1;
      const filteredChildren = originalChildren.filter(
        (child) => child.status === isActive
      );
      if (filteredChildren.length === 0) {
        return null;
      }
      return __spreadProps(__spreadValues({}, item), {
        children: filteredChildren
      });
    }
    return item;
  }).filter(
    (item) => item !== null && filterFunctions.reduce((acc, fn) => acc && fn(item), true)
  );
  return onSortFunction && sortOption ? onSortFunction(result, sortOption) : result;
}

export { filter };
